import { useMutation, useQuery } from "./urqlHooks";

const GET_HOLDING_FLOW = `
query GET_HOLDING_FLOW($companyIds: [String!]!, $currency: String!, $view: String, $showProjections: Boolean, $onlyEstimations: Boolean, $areaFilter: String!, $excludeIntercompany: Boolean) {
    getHoldingCashFlow(
        companyIds: $companyIds,
        currency: $currency, 
        view: $view,
        showProjections: $showProjections
        onlyEstimations: $onlyEstimations
        areaFilter: $areaFilter,
        excludeIntercompany: $excludeIntercompany,
    ) {
        id
        futureMonthsView
        name
        pastMonthsView
        periods {
            start
            end
            isPast
            view
        }
        primaryView
        report {
            INCOME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                        isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            EXPENSE {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                        isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            RESUME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
                companiesValues {
                    companyId
                    name
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    isVisible
                }
            }
            TOTAL {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
        }
    }
}
`;

export const GetHoldingFlow = ({ companyIds, currency, view, showProjections, onlyEstimations, areaFilter, excludeIntercompany = false }) => {
    const [result, reexecuteHoldingFlow] = useQuery({
        query: GET_HOLDING_FLOW,
        variables: { companyIds, currency, view, showProjections, onlyEstimations, areaFilter, excludeIntercompany },
    });
    const { data, fetching, error } = result;
    return { data, fetching, error, reexecuteHoldingFlow };
}


const GET_HOLDING_FLOW_STRUCTURE = `
query GET_HOLDING_FLOW_STRUCTURE($companyIds: [String!]!) {
    getHoldingFlowStructure(
        companyIds: $companyIds
    ) {
        futureMonthsView
        name
        pastMonthsView
        primaryView
        report {
            INCOME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                        isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            EXPENSE {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isVisible
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    companiesValues {
                        companyId
                        name
                        values {
                            fieldValue
                            start
                            end
                            currency
                            flowView
                            isLate
                            isProjected
                            isPast
                            isTotal
                            isClickable
                            documents
                        }
                            isVisible
                    }
                    mergedFrom
                    isMerged
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
            RESUME {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
                companiesValues {
                    companyId
                    name
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                    isVisible
                }
            }
            TOTAL {
                label
                cashflowCategoryId
                oldCategoryKey
                isIncome
                isTotal
                isDefault
                isHidden
                fields {
                    label
                    cashflowAreaId
                    isIncome
                    isVisible
                    isHidden
                    isDefault
                    values {
                        fieldValue
                        start
                        end
                        currency
                        flowView
                        isLate
                        isProjected
                        isPast
                        isTotal
                        isClickable
                        documents
                    }
                }
                values {
                    fieldValue
                    start
                    end
                    currency
                    flowView
                    isLate
                    isProjected
                    isPast
                    isTotal
                    isClickable
                    documents
                }
            }
        }
    }
}
`;

export const GetHoldingFlowStructure = ({ companyIds }) => {
    const [result, reExecuteQuery] = useQuery({
        query: GET_HOLDING_FLOW_STRUCTURE,
        variables: { companyIds },
    });
    const { data, fetching, error } = result;
    return { data, fetching, error, reExecuteQuery };
}

const MERGE_CATEGORY_AREAS = `
    mutation MERGE_CATEGORY_AREAS(
        $mergedAreaName: String!
        $targetCategoryId: String!
        $areaIdsToMerge: [String!]!
        $holdingFlowId: String!
        $companyId: String!
    ) {
        mergeCategoryAreas(
            mergedAreaName: $mergedAreaName
            targetCategoryId: $targetCategoryId
            areaIdsToMerge: $areaIdsToMerge
            holdingFlowId: $holdingFlowId
            companyId: $companyId
        ){
            status
            message
            mergedAreaId
        }
    }
`;

export const MergeCategoryAreas = () => {
    const [result, executeMutation] = useMutation(MERGE_CATEGORY_AREAS);

    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};

const UNMERGE_AREA = `
    mutation UNMERGE_AREA(
        $holdingFlowId: String!
        $mergedAreaId: String!
        $companyId: String!
    ) {
        unmergeArea(
            holdingFlowId: $holdingFlowId
            mergedAreaId: $mergedAreaId
            companyId: $companyId
        ) {
            status
            message
            mergedAreaId
        }
    }
`;

export const UnmergeArea = () => {
    const [result, executeMutation] = useMutation(UNMERGE_AREA);

    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};

const UPDATE_MERGED_AREA = `
    mutation UPDATE_MERGED_AREA(
        $holdingFlowId: String!
        $mergedAreaId: String!
        $targetCategoryId: String!
        $newName: String!
        $newAreaIds: [String!]!
        $companyId: String!
    ) {
        updateMergedArea(
            holdingFlowId: $holdingFlowId
            mergedAreaId: $mergedAreaId
            targetCategoryId: $targetCategoryId
            newName: $newName
            newAreaIds: $newAreaIds
            companyId: $companyId
        ) {
            status
            message
            mergedAreaId
        }
    }
`;

export const UpdateMergedArea = () => {
    const [result, executeMutation] = useMutation(UPDATE_MERGED_AREA);

    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation };
};